import { faPlus } from '@fortawesome/pro-light-svg-icons/faPlus';
import { faMinus } from '@fortawesome/pro-light-svg-icons/faMinus';
import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark';
import { faTrashCan } from '@fortawesome/pro-light-svg-icons/faTrashCan';
import { faGripDotsVertical } from '@fortawesome/pro-solid-svg-icons/faGripDotsVertical';
import { faAngleDown } from '@fortawesome/pro-light-svg-icons/faAngleDown';
import { faAlignJustify } from '@fortawesome/pro-light-svg-icons/faAlignJustify';
import { faMagnifyingGlass } from '@fortawesome/pro-light-svg-icons/faMagnifyingGlass';
import { faPen } from '@fortawesome/pro-light-svg-icons/faPen';
import { faEllipsisVertical } from '@fortawesome/pro-light-svg-icons/faEllipsisVertical';
import { faEllipsisH } from '@fortawesome/pro-regular-svg-icons/faEllipsisH';
import { faBarsFilter } from '@fortawesome/pro-light-svg-icons/faBarsFilter';
import { faCalendarDay } from '@fortawesome/pro-light-svg-icons/faCalendarDay';
import { faUserGroup } from '@fortawesome/pro-light-svg-icons/faUserGroup';
import { faSquareList } from '@fortawesome/pro-light-svg-icons/faSquareList';
import { faLayerGroup } from '@fortawesome/pro-light-svg-icons/faLayerGroup';
import { faMessageLines } from '@fortawesome/pro-light-svg-icons/faMessageLines';
import { faSpinnerThird } from '@fortawesome/pro-duotone-svg-icons/faSpinnerThird';
import {
  ColorIconSettings,
  CompoundIconSettings,
  CustomIconSettings,
  FixedWidthIconSettings,
  IconAnimation,
  IconRotation,
  SemanticCategory,
  IconLabel,
} from '../types';
import { faPaperPlane } from '@fortawesome/pro-solid-svg-icons/faPaperPlane';
import { faAngleRight } from '@fortawesome/pro-light-svg-icons/faAngleRight';
import { faArrowsToCircle } from '@fortawesome/pro-light-svg-icons/faArrowsToCircle';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faUserPlus } from '@fortawesome/pro-light-svg-icons/faUserPlus';
import { faUserMinus } from '@fortawesome/pro-light-svg-icons/faUserMinus';
import { faBriefcase } from '@fortawesome/pro-light-svg-icons/faBriefcase';
import { InputPipe } from '../custom/InputPipe';
import { faCheck } from '@fortawesome/pro-light-svg-icons/faCheck';
import { faAngleLeft } from '@fortawesome/pro-light-svg-icons/faAngleLeft';
import { faArrowUp } from '@fortawesome/pro-regular-svg-icons/faArrowUp';
import { faMinus as faMinusRegular } from '@fortawesome/pro-regular-svg-icons/faMinus';
import { faArrowsRotate } from '@fortawesome/pro-light-svg-icons/faArrowsRotate';
import { faHourglassStart } from '@fortawesome/pro-light-svg-icons/faHourglassStart';
import { faFlask } from '@fortawesome/pro-regular-svg-icons/faFlask';
import { faRabbitRunning } from '@fortawesome/pro-light-svg-icons/faRabbitRunning';
import { faArrowTurnDownRight } from '@fortawesome/pro-light-svg-icons/faArrowTurnDownRight';
import { faArrowCircleRight } from '@fortawesome/pro-regular-svg-icons/faArrowCircleRight';
import { faUpRightFromSquare } from '@fortawesome/pro-light-svg-icons/faUpRightFromSquare';
import { faBracketsCurly } from '@fortawesome/pro-light-svg-icons/faBracketsCurly';
import { faCopy } from '@fortawesome/pro-light-svg-icons/faCopy';
import { faThumbsUp } from '@fortawesome/pro-light-svg-icons/faThumbsUp';
import { faThumbsDown } from '@fortawesome/pro-light-svg-icons/faThumbsDown';
import { faSparkles } from '@fortawesome/pro-solid-svg-icons/faSparkles';
import { faMessages } from '@fortawesome/pro-solid-svg-icons/faMessages';
import { faClipboardListCheck } from '@fortawesome/pro-light-svg-icons/faClipboardListCheck';
import { faClockThree as faClockThree } from '@fortawesome/pro-solid-svg-icons/faClockThree';
import { faSquareChevronRight } from '@fortawesome/pro-solid-svg-icons/faSquareChevronRight';
import { faSquareChevronLeft } from '@fortawesome/pro-solid-svg-icons/faSquareChevronLeft';
import { faRedo } from '@fortawesome/pro-light-svg-icons/faRedo';
import { faCalendarAlt } from '@fortawesome/pro-regular-svg-icons/faCalendarAlt';
import { faCalendarEdit } from '@fortawesome/pro-regular-svg-icons/faCalendarEdit';

export const SEMANTIC_CATEGORY: SemanticCategory = 'action';
export type SemanticCategoryName = typeof SEMANTIC_CATEGORY;

export const icons = {
  add: faPlus,
  remove: faMinus,
  close: faXmark,
  copy: faCopy,
  like: faThumbsUp,
  dislike: faThumbsDown,
  delete: faTrashCan,
  'expand-frame': faAngleLeft,
  'collapse-frame': faAngleDown,
  'drag-handle': faGripDotsVertical,
  minimize: faMinusRegular,
  'resize-handle': faAngleDown,
  'select-icon': faAlignJustify,
  search: faMagnifyingGlass,
  edit: faPen,
  options: faEllipsisVertical,
  'options-horizontal': faEllipsisH,
  'options-alt': null,
  filter: faBarsFilter,
  'filter-date': faCalendarDay,
  'filter-team': faUserGroup,
  'filter-roles': faBriefcase,
  'filter-fields': null,
  'filter-event-type': faSquareList,
  'filter-objects': faLayerGroup,
  'filter-comments': faMessageLines,
  generate: faSparkles,
  loading: faSpinnerThird,
  refresh: faArrowsRotate,
  'add-user': faUserPlus,
  'remove-user': faUserMinus,
  'complete-activity': faCheck,
  'apply-calendar': faCalendarDay,
  'scroll-top': faArrowUp,
  'arrows-to-circle': faArrowsToCircle,
  'show-variables': faHourglassStart,
  'smartconnector-dry-run': faFlask,
  'throttle-automation': faRabbitRunning,
  'add-to-bottom': faArrowTurnDownRight,
  continue: faArrowCircleRight,
  open: faUpRightFromSquare,
  send: faAngleRight,
  'start-chat': faMessages,
  'variable-history': faBracketsCurly,
  'send-message': faPaperPlane,
  'automation-execution-list': null,
  'show-automation-execution-list': null,
  'hide-automation-execution-list': null,
  'automation-debug-rerun-step': faRedo,
  'select-calendars': faCalendarAlt,
  'connect-calendars': faCalendarEdit,
};

export const labels: IconLabel = {
  add: {
    title: (t) => '',
    description: (t) => t('Add'),
  },
  copy: {
    title: (t) => '',
    description: (t) => t('Copy'),
  },
  like: {
    title: (t) => '',
    description: (t) => t('Like'),
  },
  dislike: {
    title: (t) => '',
    description: (t) => t('Dislike'),
  },
  remove: {
    title: (t) => '',
    description: (t) => t('Remove'),
  },
  close: {
    title: (t) => '',
    description: (t) => t('Close'),
  },
  delete: {
    title: (t) => '',
    description: (t) => t('Delete'),
  },
  'drag-handle': {
    title: (t) => '',
    description: (t) => t('Drag'),
  },
  'resize-handle': {
    title: (t) => '',
    description: (t) => t('Resize'),
  },
  'select-icon': {
    title: (t) => '',
    description: (t) => t('Select'),
  },
  search: {
    title: (t) => '',
    description: (t) => t('Search'),
  },
  edit: {
    title: (t) => '',
    description: (t) => t('Edit'),
  },
  options: {
    title: (t) => '',
    description: (t) => t('Options'),
  },
  'options-horizontal': {
    title: (t) => '',
    description: (t) => t('Options'),
  },
  'options-alt': {
    title: (t) => '',
    description: (t) => t('Options'),
  },
  filter: {
    title: (t) => '',
    description: (t) => t('Filter'),
  },
  'filter-date': {
    title: (t) => '',
    description: (t) => t('Filter Date'),
  },
  'filter-team': {
    title: (t) => '',
    description: (t) => t('Filter Team'),
  },
  'filter-roles': {
    title: (t) => '',
    description: (t) => t('Filter Roles'),
  },
  'filter-fields': {
    title: (t) => '',
    description: (t) => t('Filter Fields'),
  },
  'filter-event-type': {
    title: (t) => '',
    description: (t) => t('Filter Event Type'),
  },
  'filter-objects': {
    title: (t) => '',
    description: (t) => t('Filter Objects'),
  },
  'filter-comments': {
    title: (t) => '',
    description: (t) => t('Filter Comments'),
  },
  generate: {
    title: (t) => '',
    description: (t) => t('Generate'),
  },
  loading: {
    title: (t) => '',
    description: (t) => t('Loading'),
  },
  refresh: {
    title: (t) => '',
    description: (t) => t('Refresh'),
  },
  'add-user': {
    title: (t) => '',
    description: (t) => t('Add User'),
  },
  'remove-user': {
    title: (t) => '',
    description: (t) => t('Remove User'),
  },
  'complete-activity': {
    title: (t) => '',
    description: (t) => t('Complete Activity'),
  },
  'apply-calendar': {
    title: (t) => '',
    description: (t) => t('Apply Calendar'),
  },
  minimize: {
    title: (t) => '',
    description: (t) => t('Minimize'),
  },
  'show-variables': {
    title: (t) => '',
    description: (t) => t('Hourglass'),
  },
  'smartconnector-dry-run': {
    title: (t) => '',
    description: (t) => t('Start Dry Run'),
  },
  'throttle-automation': {
    title: (t) => '',
    description: (t) => t('Throttle Agentic Workflow'),
  },
  'add-to-bottom': {
    title: (t) => '',
    description: (t) => t('Add to Bottom'),
  },
  continue: {
    title: (t) => '',
    description: (t) => t('Continue'),
  },
  open: {
    title: (t) => '',
    description: (t) => t('open'),
  },
  'variable-history': {
    title: (t) => '',
    description: (t) => t('Variable History'),
  },
  'start-chat': {
    title: (t) => '',
    description: (t) => t('Start Chat'),
  },
  'automation-execution-list': {
    title: (t) => '',
    description: (t) => t('Executions'),
  },
  'show-automation-execution-list': {
    title: (t) => '',
    description: (t) => t('Show Executions'),
  },
  'hide-automation-execution-list': {
    title: (t) => '',
    description: (t) => t('Hide Executions'),
  },
  'automation-debug-rerun-step': {
    title: (t) => '',
    description: (t) =>
      t(
        'Run this step again, using the current values for variables and fields.'
      ),
  },
  'select-calendars': {
    title: (t) => '',
    description: (t) => t('Select Calendars'),
  },
  'connect-calendars': {
    title: (t) => '',
    description: (t) => t('Connect Calendars'),
  },
};

export type ValidIcons = keyof typeof icons;

export const rotation: IconRotation = {
  'resize-handle': -45,
};

export const animation: IconAnimation = {
  loading: 'spin',
};

export const compoundIcons: CompoundIconSettings = {
  'options-alt': {
    secondary: faEllipsisVertical as IconDefinition,
    outline: 'circle',
    secondaryPosition: 'center',
    secondaryClassName: 'scale-[70%]',
  },
  'automation-execution-list': {
    primary: faClipboardListCheck as IconDefinition,
    secondary: faClockThree as IconDefinition,
    secondaryPosition: 'bottom-far-right',
    secondaryClassName: 'scale-[60%]',
  },
  'show-automation-execution-list': {
    primary: faClipboardListCheck as IconDefinition,
    secondary: faSquareChevronRight as IconDefinition,
    secondaryPosition: 'bottom-medium-right',
    secondaryClassName: 'scale-[60%]',
  },
  'hide-automation-execution-list': {
    primary: faClipboardListCheck as IconDefinition,
    secondary: faSquareChevronLeft as IconDefinition,
    secondaryPosition: 'bottom-medium-right',
    secondaryClassName: 'scale-[60%]',
  },
};

export const colorDefinitions: ColorIconSettings = {
  loading: {
    primary: 'feedback-toast-information',
    secondary: 'background-medium',
  },
};

export const customIcons: CustomIconSettings = {
  'filter-fields': InputPipe,
};

export const fixedWidthIcons: FixedWidthIconSettings = {
  close: true,
  search: true,
  loading: true,
};
